import { letters, status, letters_eng_srb } from './constants'
import { useEffect, useState } from 'react'

import { EndGameModal } from './components/EndGameModal'
import { ReactComponent as Info } from './data/Info.svg'
import { InfoModal } from './components/InfoModal'
import { Keyboard } from './components/Keyboard'
import { ReactComponent as Settings } from './data/Settings.svg'
import { SettingsModal } from './components/SettingsModal'
import Confetti from 'react-dom-confetti';
import answers from './data/answers'
import { useLocalStorage } from './hooks/useLocalStorage'
import words from './data/words'
import logo from './data/logo.png'
import { isMobile } from 'react-device-detect';

const state = {
  playing: 'playing',
  won: 'won',
  lost: 'lost',
}

const shareState = {
  notclicked: 'notclicked',
  clicked: 'clicked',
}

const confettiConfig = {
  angle: 90,
  spread: 180,
  startVelocity: 60,
  elementCount: 70,
  dragFriction: 0.12,
  duration: 2500,
  stagger: 3,
  width: "20px",
  height: "20px",
  perspective: "500px",
  colors: ["#63AA55", "#EAB308"]
};



const getRandomAnswer = () => {

  const date = getTodaysDate();

  var text = '';

if(date == '16/9/2024'){
  text = 'кавез';
}else if(date == '20/3/2025'){
                text = 'кљова';
}else if(date == '21/3/2025'){
                text = 'лабуд';
}else if(date == '22/3/2025'){
                text = 'џокер';
}else if(date == '23/3/2025'){
                text = 'рукав';
}else if(date == '24/3/2025'){
                text = 'рачун';
}else if(date == '25/3/2025'){
                text = 'шегрт';
}else if(date == '26/3/2025'){
                text = 'фраза';
}else if(date == '27/3/2025'){
                text = 'пунђа';
}else if(date == '28/3/2025'){
                text = 'хокеј';
}else if(date == '29/3/2025'){
                text = 'синод';
}else if(date == '30/3/2025'){
                text = 'лежај';
}else if(date == '31/3/2025'){
                text = 'фауна';
}else if(date == '1/4/2025'){
                text = 'љутња';
}else if(date == '2/4/2025'){
                text = 'појас';
}else if(date == '3/4/2025'){
                text = 'пират';
}else if(date == '4/4/2025'){
                text = 'лакат';
}else if(date == '5/4/2025'){
                text = 'перач';
}else if(date == '6/4/2025'){
                text = 'једро';
}else if(date == '7/4/2025'){
                text = 'копље';
}else if(date == '8/4/2025'){
                text = 'плута';
}else if(date == '9/4/2025'){
                text = 'јакна';
}else if(date == '10/4/2025'){
                text = 'калај';
}else if(date == '11/4/2025'){
                text = 'родео';
}else if(date == '12/4/2025'){
                text = 'ормар';
}else if(date == '13/4/2025'){
                text = 'мотка';
}else if(date == '14/4/2025'){
                text = 'чокот';
}else if(date == '15/4/2025'){
                text = 'лавеж';
}else if(date == '16/4/2025'){
                text = 'крзно';
}else if(date == '17/4/2025'){
                text = 'испис';
}else if(date == '18/4/2025'){
                text = 'мираз';
}else if(date == '19/4/2025'){
                text = 'минут';
}else if(date == '20/4/2025'){
                text = 'трбух';
}else if(date == '21/4/2025'){
                text = 'легат';
}else if(date == '22/4/2025'){
                text = 'најам';
}else if(date == '23/4/2025'){
                text = 'писта';
}else if(date == '24/4/2025'){
                text = 'молба';
}else if(date == '25/4/2025'){
                text = 'шамар';
}else if(date == '26/4/2025'){
                text = 'срећа';
}else if(date == '27/4/2025'){
                text = 'облик';
}else if(date == '28/4/2025'){
                text = 'зајам';
}else if(date == '29/4/2025'){
                text = 'пасус';
}else if(date == '30/4/2025'){
                text = 'ствар';
}else if(date == '1/5/2025'){
                text = 'машна';
}else if(date == '2/5/2025'){
                text = 'мућак';
}else if(date == '3/5/2025'){
                text = 'избор';
}else if(date == '4/5/2025'){
                text = 'екран';
}else if(date == '5/5/2025'){
                text = 'лапот';
}else if(date == '6/5/2025'){
                text = 'цртеж';
}else if(date == '7/5/2025'){
                text = 'скица';
}else if(date == '8/5/2025'){
                text = 'регал';
}else if(date == '9/5/2025'){
                text = 'назив';
}else if(date == '10/5/2025'){
                text = 'порив';
}else if(date == '11/5/2025'){
                text = 'цитат';
}else if(date == '12/5/2025'){
                text = 'модел';
}else if(date == '13/5/2025'){
                text = 'рекет';
}else if(date == '14/5/2025'){
                text = 'смеће';
}else if(date == '15/5/2025'){
                text = 'свест';
}else if(date == '16/5/2025'){
                text = 'стриц';
}else if(date == '17/5/2025'){
                text = 'лигња';
}else if(date == '18/5/2025'){
                text = 'ласта';
}else if(date == '19/5/2025'){
                text = 'мољац';
}else if(date == '20/5/2025'){
                text = 'бодеж';
}else if(date == '21/5/2025'){
                text = 'проза';
}else if(date == '22/5/2025'){
                text = 'чекић';
}else if(date == '23/5/2025'){
                text = 'сплет';
}else if(date == '24/5/2025'){
                text = 'проба';
}else if(date == '25/5/2025'){
                text = 'радња';
}else if(date == '26/5/2025'){
                text = 'мртав';
}else if(date == '27/5/2025'){
                text = 'шетач';
}else if(date == '28/5/2025'){
                text = 'закон';
}else if(date == '29/5/2025'){
                text = 'путар';
}else if(date == '30/5/2025'){
                text = 'џелат';
}else if(date == '31/5/2025'){
                text = 'носач';
}else if(date == '1/6/2025'){
                text = 'етапа';
}else if(date == '2/6/2025'){
                text = 'шодер';
}else if(date == '3/6/2025'){
                text = 'пораз';
}else if(date == '4/6/2025'){
                text = 'скаут';
}else if(date == '5/6/2025'){
                text = 'орган';
}else if(date == '6/6/2025'){
                text = 'нафта';
}else if(date == '7/6/2025'){
                text = 'јелен';
}else if(date == '8/6/2025'){
                text = 'смола';
}else if(date == '9/6/2025'){
                text = 'албум';
}else if(date == '10/6/2025'){
                text = 'однос';
}else if(date == '11/6/2025'){
                text = 'штета';
}else if(date == '12/6/2025'){
                text = 'мотел';
}else if(date == '13/6/2025'){
                text = 'одзив';
}else if(date == '14/6/2025'){
                text = 'креда';
}else if(date == '15/6/2025'){
                text = 'сцена';
}else if(date == '16/6/2025'){
                text = 'позив';
}else if(date == '17/6/2025'){
                text = 'седло';
}else if(date == '18/6/2025'){
                text = 'бурма';
}else if(date == '19/6/2025'){
                text = 'тонус';
}else if(date == '20/6/2025'){
                text = 'пруга';
}else if(date == '21/6/2025'){
                text = 'менза';
}else if(date == '22/6/2025'){
                text = 'отмен';
}else if(date == '23/6/2025'){
                text = 'пушач';
}else if(date == '24/6/2025'){
                text = 'вајар';
}else if(date == '25/6/2025'){
                text = 'стрип';
}else if(date == '26/6/2025'){
                text = 'опсег';
}else if(date == '27/6/2025'){
                text = 'слама';
}else if(date == '28/6/2025'){
                text = 'конус';
}else if(date == '29/6/2025'){
                text = 'набој';
}else if(date == '30/6/2025'){
                text = 'амеба';
}else if(date == '1/7/2025'){
                text = 'улога';
}else if(date == '2/7/2025'){
                text = 'огрев';
}else if(date == '3/7/2025'){
                text = 'нишан';
}else if(date == '4/7/2025'){
                text = 'пауза';
}else if(date == '5/7/2025'){
                text = 'ловац';
}else if(date == '6/7/2025'){
                text = 'самрт';
}else if(date == '7/7/2025'){
                text = 'хотел';
}else if(date == '8/7/2025'){
                text = 'ћитап';
}else if(date == '9/7/2025'){
                text = 'патос';
}else if(date == '10/7/2025'){
                text = 'аларм';
}else if(date == '11/7/2025'){
                text = 'елита';
}else if(date == '12/7/2025'){
                text = 'снаја';
}else if(date == '13/7/2025'){
                text = 'ћурка';
}else if(date == '14/7/2025'){
                text = 'обзир';
}else if(date == '15/7/2025'){
                text = 'завој';
}else if(date == '16/7/2025'){
                text = 'тањир';
}else if(date == '17/7/2025'){
                text = 'свађа';
}else if(date == '18/7/2025'){
                text = 'башта';
}else if(date == '19/7/2025'){
                text = 'ортак';
}else if(date == '20/7/2025'){
                text = 'памук';
}else if(date == '21/7/2025'){
                text = 'извор';
}else if(date == '22/7/2025'){
                text = 'посао';
}else if(date == '23/7/2025'){
                text = 'метар';
}else if(date == '24/7/2025'){
                text = 'рафал';
}else if(date == '25/7/2025'){
                text = 'јарма';
}else if(date == '26/7/2025'){
                text = 'санке';
}else if(date == '27/7/2025'){
                text = 'залет';
}else if(date == '28/7/2025'){
                text = 'иступ';
}else if(date == '29/7/2025'){
                text = 'окрет';
}else if(date == '30/7/2025'){
                text = 'левак';
}else if(date == '31/7/2025'){
                text = 'кифла';
}else if(date == '1/8/2025'){
                text = 'сукња';
}else if(date == '2/8/2025'){
                text = 'чопор';
}else if(date == '3/8/2025'){
                text = 'забит';
}else if(date == '4/8/2025'){
                text = 'свећа';
}else if(date == '5/8/2025'){
                text = 'метла';
}else if(date == '6/8/2025'){
                text = 'сплав';
}else if(date == '7/8/2025'){
                text = 'звање';
}else if(date == '8/8/2025'){
                text = 'редар';
}else if(date == '9/8/2025'){
                text = 'сајла';
}else if(date == '10/8/2025'){
                text = 'епоха';
}else if(date == '11/8/2025'){
                text = 'одмах';
}else if(date == '12/8/2025'){
                text = 'змија';
}else if(date == '13/8/2025'){
                text = 'даска';
}else if(date == '14/8/2025'){
                text = 'ваљак';
}else if(date == '15/8/2025'){
                text = 'узица';
}else if(date == '16/8/2025'){
                text = 'пакет';
}else if(date == '17/8/2025'){
                text = 'ензим';
}else if(date == '18/8/2025'){
                text = 'злоћа';
}else if(date == '19/8/2025'){
                text = 'преса';
}else if(date == '20/8/2025'){
                text = 'трска';
}else if(date == '21/8/2025'){
                text = 'флора';
}else if(date == '22/8/2025'){
                text = 'одело';
}else if(date == '23/8/2025'){
                text = 'супер';
}else if(date == '24/8/2025'){
                text = 'сфера';
}else if(date == '25/8/2025'){
                text = 'течај';
}else if(date == '26/8/2025'){
                text = 'колац';
}else if(date == '27/8/2025'){
                text = 'коцка';
}else if(date == '28/8/2025'){
                text = 'самба';
}else if(date == '29/8/2025'){
                text = 'игало';
}else if(date == '30/8/2025'){
                text = 'извоз';
}else if(date == '31/8/2025'){
                text = 'орден';
}else if(date == '1/9/2025'){
                text = 'напор';
}else if(date == '2/9/2025'){
                text = 'налет';
}else if(date == '3/9/2025'){
                text = 'цифра';
}else if(date == '4/9/2025'){
                text = 'тајна';
}else if(date == '5/9/2025'){
                text = 'рођак';
}else if(date == '6/9/2025'){
                text = 'петља';
}else if(date == '7/9/2025'){
                text = 'клица';
}else if(date == '8/9/2025'){
                text = 'степа';
}else if(date == '9/9/2025'){
                text = 'педер';
}else if(date == '10/9/2025'){
                text = 'кадар';
}else if(date == '11/9/2025'){
                text = 'олтар';
}else if(date == '12/9/2025'){
                text = 'океан';
}else if(date == '13/9/2025'){
                text = 'идила';
}else if(date == '14/9/2025'){
                text = 'копач';
}else if(date == '15/9/2025'){
                text = 'нинџа';
}else if(date == '16/9/2025'){
                text = 'стање';
}else if(date == '17/9/2025'){
                text = 'слуга';
}else if(date == '18/9/2025'){
                text = 'пасуљ';
}else if(date == '19/9/2025'){
                text = 'аљкав';
}else if(date == '20/9/2025'){
                text = 'сафир';
}else if(date == '21/9/2025'){
                text = 'фарса';
}else if(date == '22/9/2025'){
                text = 'прота';
}else if(date == '23/9/2025'){
                text = 'запах';
}else if(date == '24/9/2025'){
                text = 'човек';
}else if(date == '25/9/2025'){
                text = 'квант';
}else if(date == '26/9/2025'){
                text = 'благо';
}else if(date == '27/9/2025'){
                text = 'журба';
}else if(date == '28/9/2025'){
                text = 'којот';
}else if(date == '29/9/2025'){
                text = 'лудак';
}else if(date == '30/9/2025'){
                text = 'поход';
}else if(date == '1/10/2025'){
                text = 'оглас';
}else if(date == '2/10/2025'){
                text = 'насип';
}else if(date == '3/10/2025'){
                text = 'харфа';
}else if(date == '4/10/2025'){
                text = 'шкрга';
}else if(date == '5/10/2025'){
                text = 'мачор';
}else if(date == '6/10/2025'){
                text = 'ивица';
}else if(date == '7/10/2025'){
                text = 'тарот';
}else if(date == '8/10/2025'){
                text = 'флека';
}else if(date == '9/10/2025'){
                text = 'пркос';
}else if(date == '10/10/2025'){
                text = 'стега';
}else if(date == '11/10/2025'){
                text = 'шешир';
}else if(date == '12/10/2025'){
                text = 'финиш';
}else if(date == '13/10/2025'){
                text = 'пазух';
}else if(date == '14/10/2025'){
                text = 'труба';
}else if(date == '15/10/2025'){
                text = 'черга';
}else if(date == '16/10/2025'){
                text = 'жвака';
}else if(date == '17/10/2025'){
                text = 'јахта';
}else if(date == '18/10/2025'){
                text = 'букет';
}else if(date == '19/10/2025'){
                text = 'испит';
}else if(date == '20/10/2025'){
                text = 'опека';
}else if(date == '21/10/2025'){
                text = 'слово';
}else if(date == '22/10/2025'){
                text = 'штиво';
}else if(date == '23/10/2025'){
                text = 'ротор';
}else if(date == '24/10/2025'){
                text = 'омлет';
}else if(date == '25/10/2025'){
                text = 'опело';
}else if(date == '26/10/2025'){
                text = 'надев';
}else if(date == '27/10/2025'){
                text = 'шворц';
}else if(date == '28/10/2025'){
                text = 'отвор';
}else if(date == '29/10/2025'){
                text = 'жамор';
}else if(date == '30/10/2025'){
                text = 'пумпа';
}else if(date == '31/10/2025'){
                text = 'возач';
}else if(date == '1/11/2025'){
                text = 'полет';
}else if(date == '2/11/2025'){
                text = 'образ';
}else if(date == '3/11/2025'){
                text = 'оцена';
}else if(date == '4/11/2025'){
                text = 'џоинт';
}else if(date == '5/11/2025'){
                text = 'икона';
}else if(date == '6/11/2025'){
                text = 'слава';
}else if(date == '7/11/2025'){
                text = 'жвала';
}else if(date == '8/11/2025'){
                text = 'ловор';
}else if(date == '9/11/2025'){
                text = 'табан';
}else if(date == '10/11/2025'){
                text = 'карта';
}else if(date == '11/11/2025'){
                text = 'жудња';
}else if(date == '12/11/2025'){
                text = 'кокош';
}else if(date == '13/11/2025'){
                text = 'точак';
}else if(date == '14/11/2025'){
                text = 'кугла';
}else if(date == '15/11/2025'){
                text = 'клише';
}else if(date == '16/11/2025'){
                text = 'тегла';
}else if(date == '17/11/2025'){
                text = 'сеоба';
}else if(date == '18/11/2025'){
                text = 'оксид';
}else if(date == '19/11/2025'){
                text = 'осмех';
}else if(date == '20/11/2025'){
                text = 'једра';
}else if(date == '21/11/2025'){
                text = 'тркач';
}else if(date == '22/11/2025'){
                text = 'помак';
}else if(date == '23/11/2025'){
                text = 'визир';
}else if(date == '24/11/2025'){
                text = 'повез';
}else if(date == '25/11/2025'){
                text = 'котур';
}else if(date == '26/11/2025'){
                text = 'одсек';
}else if(date == '27/11/2025'){
                text = 'сидро';
}else if(date == '28/11/2025'){
                text = 'товар';
}else if(date == '29/11/2025'){
                text = 'нацрт';
}else if(date == '30/11/2025'){
                text = 'излог';
}else if(date == '1/12/2025'){
                text = 'млеко';
}else if(date == '2/12/2025'){
                text = 'крава';
}else if(date == '3/12/2025'){
                text = 'мемла';
}else if(date == '4/12/2025'){
                text = 'амбис';
}else if(date == '5/12/2025'){
                text = 'шарка';
}else if(date == '6/12/2025'){
                text = 'трафо';
}else if(date == '7/12/2025'){
                text = 'крчма';
}else if(date == '8/12/2025'){
                text = 'шатор';
}else if(date == '9/12/2025'){
                text = 'чобан';
}else if(date == '10/12/2025'){
                text = 'нитна';
}else if(date == '11/12/2025'){
                text = 'бонус';
}else if(date == '12/12/2025'){
                text = 'завет';
}else if(date == '13/12/2025'){
                text = 'рачва';
}else if(date == '14/12/2025'){
                text = 'израз';
}else if(date == '15/12/2025'){
                text = 'шабан';
}else if(date == '16/12/2025'){
                text = 'непце';
}else if(date == '17/12/2025'){
                text = 'сачма';
}else if(date == '18/12/2025'){
                text = 'кадет';
}else if(date == '19/12/2025'){
                text = 'отпад';
}else if(date == '20/12/2025'){
                text = 'трење';
}else if(date == '21/12/2025'){
                text = 'врста';
}else if(date == '22/12/2025'){
                text = 'склоп';
}else if(date == '23/12/2025'){
                text = 'амбар';
}else if(date == '24/12/2025'){
                text = 'излаз';
}else if(date == '25/12/2025'){
                text = 'идеја';
}else if(date == '26/12/2025'){
                text = 'панда';
}else if(date == '27/12/2025'){
                text = 'пилот';
}else if(date == '28/12/2025'){
                text = 'рашље';
}else if(date == '29/12/2025'){
                text = 'раван';
}else if(date == '30/12/2025'){
                text = 'шишке';
}else if(date == '31/12/2025'){
                text = 'кашаљ';
}else if(date == '1/1/2026'){
                text = 'нотар';
}else if(date == '2/1/2026'){
                text = 'низак';
}else if(date == '3/1/2026'){
                text = 'суфле';
}else if(date == '4/1/2026'){
                text = 'замак';
}else if(date == '5/1/2026'){
                text = 'лопта';
}else if(date == '6/1/2026'){
                text = 'потаж';
}else if(date == '7/1/2026'){
                text = 'алиби';
}else if(date == '8/1/2026'){
                text = 'уцена';
}else if(date == '9/1/2026'){
                text = 'газда';
}else if(date == '10/1/2026'){
                text = 'јатак';
}else if(date == '11/1/2026'){
                text = 'хрчак';
}else if(date == '12/1/2026'){
                text = 'варка';
}else if(date == '13/1/2026'){
                text = 'намаз';
}else if(date == '14/1/2026'){
                text = 'кулен';
}else if(date == '15/1/2026'){
                text = 'циста';
}else if(date == '16/1/2026'){
                text = 'лимит';
}else if(date == '17/1/2026'){
                text = 'лимфа';
}else if(date == '18/1/2026'){
                text = 'архив';
}else if(date == '19/1/2026'){
                text = 'ревер';
}else if(date == '20/1/2026'){
                text = 'тајац';
}else if(date == '21/1/2026'){
                text = 'засад';
}else if(date == '22/1/2026'){
                text = 'ковач';
}else if(date == '23/1/2026'){
                text = 'створ';
}else if(date == '24/1/2026'){
                text = 'принц';
}else if(date == '25/1/2026'){
                text = 'фарба';
}else if(date == '26/1/2026'){
                text = 'бутик';
}else if(date == '27/1/2026'){
                text = 'изрод';
}else if(date == '28/1/2026'){
                text = 'кутак';
}else if(date == '29/1/2026'){
                text = 'пепео';
}else if(date == '30/1/2026'){
                text = 'манир';
}else if(date == '31/1/2026'){
                text = 'сенка';
}else if(date == '1/2/2026'){
                text = 'лупеж';
}else if(date == '2/2/2026'){
                text = 'нагиб';
}else if(date == '3/2/2026'){
                text = 'чалма';
}else if(date == '4/2/2026'){
                text = 'тумор';
}else if(date == '5/2/2026'){
                text = 'капут';
}else if(date == '6/2/2026'){
                text = 'плима';
}else if(date == '7/2/2026'){
                text = 'жилет';
}else if(date == '8/2/2026'){
                text = 'класа';
}else if(date == '9/2/2026'){
                text = 'метал';
}else if(date == '10/2/2026'){
                text = 'фрула';
}else if(date == '11/2/2026'){
                text = 'терме';
}else if(date == '12/2/2026'){
                text = 'мазга';
}else if(date == '13/2/2026'){
                text = 'морал';
}else if(date == '14/2/2026'){
                text = 'криза';
}else if(date == '15/2/2026'){
                text = 'цуцла';
}else if(date == '16/2/2026'){
                text = 'номад';
}else if(date == '17/2/2026'){
                text = 'оскар';
}else if(date == '18/2/2026'){
                text = 'покољ';
}else if(date == '19/2/2026'){
                text = 'опрез';
}else if(date == '20/2/2026'){
                text = 'олуја';
}else if(date == '21/2/2026'){
                text = 'мрљав';
}else if(date == '22/2/2026'){
                text = 'купач';
}else if(date == '23/2/2026'){
                text = 'паста';
}else if(date == '24/2/2026'){
                text = 'пушка';
}else if(date == '25/2/2026'){
                text = 'савез';
}else if(date == '26/2/2026'){
                text = 'корзо';
}else if(date == '27/2/2026'){
                text = 'етика';
}else if(date == '28/2/2026'){
                text = 'корен';
}else if(date == '1/3/2026'){
                text = 'основ';
}else if(date == '2/3/2026'){
                text = 'комад';
}else if(date == '3/3/2026'){
                text = 'проја';
}else if(date == '4/3/2026'){
                text = 'јецај';
}else if(date == '5/3/2026'){
                text = 'украс';
}else if(date == '6/3/2026'){
                text = 'излет';
}else if(date == '7/3/2026'){
                text = 'помоћ';
}else if(date == '8/3/2026'){
                text = 'имање';
}else if(date == '9/3/2026'){
                text = 'лонче';
}else if(date == '10/3/2026'){
                text = 'јарак';
}else if(date == '11/3/2026'){
                text = 'кофер';
}else if(date == '12/3/2026'){
                text = 'мамут';
}else if(date == '13/3/2026'){
                text = 'немоћ';
}else if(date == '14/3/2026'){
                text = 'покор';
}else if(date == '15/3/2026'){
                text = 'мачак';
}else if(date == '16/3/2026'){
                text = 'крађа';
}else if(date == '17/3/2026'){
                text = 'пенал';
}else if(date == '18/3/2026'){
                text = 'гелер';
}else if(date == '19/3/2026'){
                text = 'типка';
}else if(date == '20/3/2026'){
                text = 'поноћ';
}else if(date == '21/3/2026'){
                text = 'осврт';
}else if(date == '22/3/2026'){
                text = 'алеја';
}else if(date == '23/3/2026'){
                text = 'уздах';
}else if(date == '24/3/2026'){
                text = 'женка';
}else if(date == '25/3/2026'){
                text = 'жарач';
}else if(date == '26/3/2026'){
                text = 'маржа';
}else if(date == '27/3/2026'){
                text = 'месар';
}else if(date == '28/3/2026'){
                text = 'сокак';
}else if(date == '29/3/2026'){
                text = 'исток';
}else if(date == '30/3/2026'){
                text = 'херој';
}else if(date == '31/3/2026'){
                text = 'извод';
} else {
    text = 'ништа';
}

  return btoa(unescape(encodeURIComponent((text.toUpperCase()))))
}

const getTodaysDate = () => {
  const current = new Date();
  const date = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
  return date;
}





function App() {
  const initialStates = {
    answer: () => getRandomAnswer(),
    gameState: state.playing,
    gameShareState: state.notclicked,
    board: [
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
      ['', '', '', '', ''],
    ],
    cellStatuses: Array(6).fill(Array(5).fill(status.unguessed)),
    currentRow: 0,
    currentCol: 0,
    letterStatuses: () => {
      const letterStatuses = {}
      letters.forEach((letter) => {
        letterStatuses[letter] = status.unguessed
      })
      return letterStatuses
    },
    submittedInvalidWord: false,
    dateToday: () => getTodaysDate(),
  }

  const [answer, setAnswer] = useLocalStorage('stateAnswer', initialStates.answer())
  const [gameState, setGameState] = useLocalStorage('stateGameState', initialStates.gameState)
  const [board, setBoard] = useLocalStorage('stateBoard', initialStates.board)
  const [cellStatuses, setCellStatuses] = useLocalStorage('stateCellStatuses', initialStates.cellStatuses)
  const [currentRow, setCurrentRow] = useLocalStorage('stateCurrentRow', initialStates.currentRow)
  const [currentCol, setCurrentCol] = useLocalStorage('stateCurrentCol', initialStates.currentCol)
  const [letterStatuses, setLetterStatuses] = useLocalStorage('stateLetterStatuses', initialStates.letterStatuses())
  const [submittedInvalidWord, setSubmittedInvalidWord] = useLocalStorage('stateSubmittedInvalidWord', initialStates.submittedInvalidWord)
  const [dateToday, setDateToday] = useLocalStorage('stateDate', initialStates.dateToday)

  const [currentStreak, setCurrentStreak] = useLocalStorage('current-streak', 0)
  const [longestStreak, setLongestStreak] = useLocalStorage('longest-streak', 0)
  const [modalIsOpen, setIsOpen] = useState(false)
  const [firstTime, setFirstTime] = useLocalStorage('first-time', true)
  const [infoModalIsOpen, setInfoModalIsOpen] = useState(firstTime)
  const [settingsModalIsOpen, setSettingsModalIsOpen] = useState(false)

  const [playConfetti, setPlayConfetti] = useState(false)

  const openModal = () => setIsOpen(true)

  const handleInfoClose = () => {
    setFirstTime(false)
    setInfoModalIsOpen(false)
  }

  const handleEndGameClose = () => {
    setIsOpen(false)
    playAgain()
  }



  const check = () => {
    if (getTodaysDate() != dateToday) {
      playAgain();
    }

  }

  useEffect(() => {
    check()
  }, [initialStates])

  const [darkMode, setDarkMode] = useLocalStorage('dark-mode', false)
  const toggleDarkMode = () => setDarkMode((prev) => !prev)

  useEffect(() => {
    if (gameState !== state.playing) {
      setTimeout(() => {
        setPlayConfetti(false)
        openModal()
      }, 4500)

      setTimeout(() => {
        setPlayConfetti(true)
      }, 2500)

    }
  }, [gameState])



  const getCellStyles = (rowNumber, colNumber, letter) => {
    if (rowNumber === currentRow) {
      if (letter) {
        return `animate__animated animate__pulse animate__faster nm-inset-background dark:nm-inset-background-dark text-primary dark:text-primary-dark ${submittedInvalidWord ? 'border border-red-800' : ''
          }`
      }
      return 'nm-flat-background dark:nm-flat-background-dark text-primary dark:text-primary-dark'
    }

    var delay = ''
    if (rowNumber == currentRow - 1) {
      delay = 'delay-col-' + colNumber + ' '
    }

    switch (cellStatuses[rowNumber][colNumber]) {
      case status.green:
        return delay + 'nm-inset-n-green text-gray-50 animate__animated animate__flipInX'
      case status.yellow:
        return delay + 'nm-inset-yellow-500 text-gray-50 animate__animated animate__flipInX'
      case status.gray:
        return delay + 'nm-inset-n-gray text-gray-50 animate__animated animate__flipInX'
      default:
        return 'nm-flat-background dark:nm-flat-background-dark text-primary dark:text-primary-dark'
    }
  }


  const getDelay = (colNumber) => {
    return 'animationDelay:' + colNumber + 's '
  }



  const getCellStylesForSharing = (rowNumber, colNumber) => {
    switch (cellStatuses[rowNumber][colNumber]) {
      case status.green:
        return '🟢'
      case status.yellow:
        return '🟡'
      case status.gray:
        return '⚫'
      default:
        return 'nm-flat-background dark:nm-flat-background-dark text-primary dark:text-primary-dark'
    }
  }





  const addLetter = (letter) => {
    setSubmittedInvalidWord(false)
    setBoard((prev) => {
      if (currentCol > 4) {
        return prev
      }
      const newBoard = [...prev]
      newBoard[currentRow][currentCol] = letter
      return newBoard
    })
    if (currentCol < 5) {
      setCurrentCol((prev) => prev + 1)
    }
  }

  const addLetterEng = (letter) => {
    setSubmittedInvalidWord(false)
    setBoard((prev) => {
      if (currentCol > 4) {
        return prev
      }
      const newBoard = [...prev]
      newBoard[currentRow][currentCol] = letterEngToSrb(letter)
      return newBoard
    })
    if (currentCol < 5) {
      setCurrentCol((prev) => prev + 1)
    }
  }


  const letterEngToSrb = (letter) => {
    return letters_eng_srb[1][letters_eng_srb[0].indexOf(letter)];
  }


  const isValidWord = (word) => {
    if (word.length < 5) return false
    return words[word.toLowerCase()]
  }


  const onEnterPress = () => {
    const word = board[currentRow].join('')
    if (!isValidWord(word)) {
      setSubmittedInvalidWord(true)
      return
    }

    if (currentRow === 6) return

    updateCellStatuses(word, currentRow)
    updateLetterStatuses(word)
    setCurrentRow((prev) => prev + 1)
    setCurrentCol(0)
  }

  const onDeletePress = () => {
    setSubmittedInvalidWord(false)
    if (currentCol === 0) return

    setBoard((prev) => {
      const newBoard = [...prev]
      newBoard[currentRow][currentCol - 1] = ''
      return newBoard
    })

    setCurrentCol((prev) => prev - 1)
  }

  const updateCellStatuses = (word, rowNumber) => {
    setCellStatuses((prev) => {
      const newCellStatuses = [...prev]
      newCellStatuses[rowNumber] = [...prev[rowNumber]]
      const wordLength = word.length
      const answerLetters = decodeURIComponent(escape(window.atob((answer)))).split('')

      // set all to gray
      for (let i = 0; i < wordLength; i++) {
        newCellStatuses[rowNumber][i] = status.gray
      }

      // check greens
      for (let i = wordLength - 1; i >= 0; i--) {
        if (word[i] === decodeURIComponent(escape(window.atob(answer)))[i]) {
          newCellStatuses[rowNumber][i] = status.green
          answerLetters.splice(i, 1)
        }
      }

      // check yellows
      for (let i = 0; i < wordLength; i++) {
        if (answerLetters.includes(word[i]) && newCellStatuses[rowNumber][i] !== status.green) {
          newCellStatuses[rowNumber][i] = status.yellow
          answerLetters.splice(answerLetters.indexOf(word[i]), 1)
        }
      }

      return newCellStatuses
    })
  }

  const isRowAllGreen = (row) => {
    return row.every((cell) => cell === status.green)
  }

  // every time cellStatuses updates, check if the game is won or lost
  useEffect(() => {
    const cellStatusesCopy = [...cellStatuses]
    const reversedStatuses = cellStatusesCopy.reverse()
    const lastFilledRow = reversedStatuses.find((r) => {
      return r[0] !== status.unguessed
    })

    if (gameState === state.playing && lastFilledRow && isRowAllGreen(lastFilledRow)) {
      setGameState(state.won)

      //shareResult()

      var streak = currentStreak + 1
      setCurrentStreak(streak)
      setLongestStreak((prev) => streak > prev ? streak : prev)
    } else if (gameState === state.playing && currentRow === 6) {
      setGameState(state.lost)
      setCurrentStreak(0)
    }
  }, [
    cellStatuses, currentRow, gameState, setGameState,
    currentStreak, setCurrentStreak, setLongestStreak
  ])

  const updateLetterStatuses = (word) => {
    setLetterStatuses((prev) => {
      const newLetterStatuses = { ...prev }
      const wordLength = word.length
      for (let i = 0; i < wordLength; i++) {
        if (newLetterStatuses[word[i]] === status.green) continue

        if (word[i] === decodeURIComponent(escape(window.atob(answer)))[i]) {
          newLetterStatuses[word[i]] = status.green
        } else if (decodeURIComponent(escape(window.atob(answer))).includes(word[i])) {
          newLetterStatuses[word[i]] = status.yellow
        } else {
          newLetterStatuses[word[i]] = status.gray
        }
      }
      return newLetterStatuses
    })
  }


  const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }


  const playAgain = () => {

    // redirect to mobile if mobile and Android
    if (isMobile) {
      //console.log('mobile');
      //console.log(firstTime);
      if (firstTime) {
        let os = getMobileOperatingSystem();
        if (os == "Android") {
          window.location.replace("https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=pm.f2p.vordli");
        } else if (os == "iOS") {
          window.location.replace("https://apps.apple.com/us/app/vordli/id1613087917");
        } else if (os == "Windows Phone") {
          //window.location.href = "http://www.WindowsPhoneexample.com";
        } else {
          //window.location.href = "http://www.NowherLandexample.com";
        }
      }

    } else {
      //console.log('desktop');

    };
    //


    setDateToday(initialStates.dateToday)
    setAnswer(initialStates.answer())
    setGameState(initialStates.gameState)
    setBoard(initialStates.board)
    setCellStatuses(initialStates.cellStatuses)
    setCurrentRow(initialStates.currentRow)
    setCurrentCol(initialStates.currentCol)
    setLetterStatuses(initialStates.letterStatuses())
    setSubmittedInvalidWord(initialStates.submittedInvalidWord)


    //handleEndGameClose()
  }


  const shareResult = () => {
    const date = dateToday;

    var text = '';
    for (let i = 0; i < currentRow; i++) {
      for (let j = 0; j < 5; j++) {
        text += getCellStylesForSharing(i, j)
      }
      text += '\n';
    }


    const shareData = {
      title: 'Вордли',
      text: '\'Вордли - Погоди реч\' за ' + date + ': ' + currentRow + '/6\n' + text + '',
      url: ''
    }

    try {
      navigator.share(shareData)
      //sucess
    } catch (err) {
      var textField = document.createElement('textarea')
      textField.value = '\'Вордли - Погоди реч\' за ' + date + ': ' + currentRow + '/6\n' + text + 'vordli.com'


      document.body.appendChild(textField)
      textField.select()
      document.execCommand('copy')
      textField.remove()
    }




  }


  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: darkMode ? 'hsl(231, 16%, 25%)' : 'hsl(231, 16%, 92%)',
      zIndex: 99,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      height: 'calc(100% - 2rem)',
      width: 'calc(100% - 2rem)',
      backgroundColor: darkMode ? 'hsl(231, 16%, 25%)' : 'hsl(231, 16%, 92%)',
      boxShadow: `${darkMode
          ? '0.2em 0.2em calc(0.2em * 2) #252834, calc(0.2em * -1) calc(0.2em * -1) calc(0.2em * 2) #43475C'
          : '0.2em 0.2em calc(0.2em * 2) #A3A7BD, calc(0.2em * -1) calc(0.2em * -1) calc(0.2em * 2) #FFFFFF'
        }`,
      border: 'none',
      borderRadius: '1rem',
      maxWidth: '475px',
      maxHeight: '750px',
      position: 'relative',
    },
  }

  return (
    <div className={darkMode ? 'dark' : ''}>
      <div className={`flex flex-col justify-between h-fill bg-background dark:bg-background-dark`}>
        <header className="flex items-center py-2 px-3 text-primary dark:text-primary-dark">
          <button
            type="button"
            onClick={() => setSettingsModalIsOpen(true)}
            className="p-1 rounded-full"
          >
            <Settings />
          </button>



          <h1 className="flex-1 text-center text-xl xxs:text-2xl sm:text-4xl tracking-wide font-bold font-righteous animate__animated animate__slideInDown">
            <img src={logo} alt="logo" className="inline-flex items-center justify-center w-10 h-10 " /> ВОРДЛИ
          </h1>
          <button
            type="button"
            onClick={() => setInfoModalIsOpen(true)}
            className="p-1 rounded-full"
          >
            <Info />
          </button>
        </header>
        <div className="flex items-center flex-col py-3 flex-1 justify-center relative">
          <div className="relative">
            <div className="grid grid-cols-5 grid-flow-row gap-4">
              {board.map((row, rowNumber) =>
                row.map((letter, colNumber) => (
                  <span
                    key={colNumber}


                    className={`${getCellStyles(
                      rowNumber,
                      colNumber,
                      letter
                    )} inline-flex items-center font-medium justify-center text-lg w-[13vw] h-[13vw] xs:w-14 xs:h-14 sm:w-20 sm:h-20 rounded-full`}



                  >
                    {letter}
                  </span>
                ))
              )}
            </div>
            <div
              className={`absolute -bottom-24 left-1/2 transform -translate-x-1/2 ${gameState === state.playing ? 'hidden' : ''
                }`}
            >

              {/*



              <div className={darkMode ? 'dark' : ''}>
                <button
                  type="button"
                  className="rounded-lg z-10 px-6 py-2 text-lg nm-flat-background dark:nm-flat-background-dark hover:nm-inset-background dark:hover:nm-inset-background-dark text-primary dark:text-primary-dark"
                  onClick={playAgain}
                >
                  Покушај поново
                </button>
              </div>

              */}


            </div>
          </div>
          <Confetti active={playConfetti} config={confettiConfig} />
        </div>
        <InfoModal
          isOpen={infoModalIsOpen}
          handleClose={handleInfoClose}
          darkMode={darkMode}
          styles={modalStyles}
        />
        <EndGameModal
          isOpen={modalIsOpen}
          handleClose={handleEndGameClose}
          styles={modalStyles}
          darkMode={darkMode}
          gameState={gameState}
          state={state}
          currentStreak={currentStreak}
          longestStreak={longestStreak}
          answer={answer}
          playAgain={playAgain}
          shareResult={shareResult}
        />
        <SettingsModal
          isOpen={settingsModalIsOpen}
          handleClose={() =>
            setSettingsModalIsOpen(false)
          }
          styles={modalStyles}
          darkMode={darkMode}
          toggleDarkMode={toggleDarkMode}
        />
        <div className={`h-auto pb-10 relative ${gameState === state.playing ? '' : 'delay-2600 animate__animated animate__zoomOutDown'}`}>
          <Keyboard
            letterStatuses={letterStatuses}
            addLetter={addLetter}
            onEnterPress={onEnterPress}
            onDeletePress={onDeletePress}
            gameDisabled={gameState !== state.playing}
            addLetterEng={addLetterEng}
          />
        </div>


      </div>

    </div>

  )
}

export default App
